import React from "react";
import { motion } from "framer-motion";

const BonusesSection: React.FC = () => {

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <motion.div
          animate={{ 
            x: [0, 50, 0],
            y: [0, -30, 0],
            rotate: [0, 180, 360]
          }}
          transition={{ 
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
          className="absolute top-1/4 left-1/4 w-40 h-40 bg-red-500/5 rounded-full blur-2xl"
        />
        <motion.div
          animate={{ 
            x: [0, -40, 0],
            y: [0, 20, 0],
            rotate: [360, 180, 0]
          }}
          transition={{ 
            duration: 15,
            repeat: Infinity,
            ease: "linear",
            delay: 5
          }}
          className="absolute bottom-1/4 right-1/4 w-32 h-32 bg-red-600/5 rounded-full blur-xl"
        />
      </div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              Exclusive Bonuses for Attendees
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
        </motion.div>

        <div className="grid grid-cols-2 gap-8 max-w-4xl mx-auto">
          {[1, 2, 3, 4].map((index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50, rotateX: -15 }}
              whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
              transition={{ 
                duration: 0.8, 
                delay: index * 0.15,
                type: "spring",
                stiffness: 100
              }}
              viewport={{ once: true }}
              className="rounded-2xl overflow-hidden"
            >
              {/* Zylu Bonus Image */}
              <img 
                src={index === 4 ? `/zylu-Bonus4.png` : `/Zylu-Bonus${index}.png`} 
                alt={`Zylu Bonus ${index}`}
                className="w-full h-auto object-cover"
              />
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BonusesSection;
